<script>
export default {
  name: 'CallHistory'
}
</script>

<template>
  <div class="px-4">
    <div class="mb-2">
      <span class="text-medium text-theme-black-850">最近一次拨打</span>
    </div>
    <div>
      <el-form label-width="100px">
        <el-form-item label="主叫号码">xxx</el-form-item>
        <el-form-item label="被叫号码">xxx</el-form-item>
        <el-form-item label="呼叫时间">xxx</el-form-item>
        <el-form-item label="呼叫结果">xxx</el-form-item>
        <el-form-item label="外呼总时长">xxx</el-form-item>
        <el-form-item label="通话录音">xxx</el-form-item>
      </el-form>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .el-form-item {
    margin-bottom: 0 !important;
  }
</style>